module.exports = __webpack_public_path__ + "fef899f77d16dd7acee75045ec08e67c.png";